import { SocialLinks } from '@/components/ui/social-links';
import { cn } from '@/lib/utils';

interface HeaderMetaProps {
  className?: string;
  variant?: 'default' | 'dark';
}

export function HeaderMeta({ className = '', variant = 'default' }: HeaderMetaProps) {
  const textClass = variant === 'dark' ? 'text-white/60 hover:text-white' : '';
  return (
    <div className={cn('flex items-center', className)}>
      <SocialLinks variant="compact" className={textClass} />
    </div>
  );
}
